<template>
  <div class="wrapper">
    <side-bar
      v-if="!$route.meta.hideSidebar"
      type="sidebar"
      :sidebar-links="$sidebar.sidebarLinks"
    >
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel" :class="{ darkTheme: darkTheme }">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import UserMenu from "src/components/UIComponents/SidebarPlugin/UserMenu.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    UserMenu
  },
  data() {
    return {
      darkTheme: true
    };
  },
  created() {
    this.darkTheme = JSON.parse(localStorage.getItem("darkTheme"));
    this.$bus.$on("darkTheme", theme => {
      this.darkTheme = theme;
    });
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
